import { useEffect, useState } from "react";
import { getHomesList } from "../../services/home/homeService";
import { HomesCard } from "../cards/HomesCard";
import Loader from "../common/Loader";

export const HomePageTable: React.FC = () => {
    const [homes, setHomes] = useState<any[]>([]);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        setLoading(true);
        getHomesList()
            .then((res) => {
                setHomes(res);
            })
            .catch((err) => {
                console.error(err);
            })
            .finally(() => {
                setLoading(false);
            });
    }, []);


    if (loading) {
        return (
            <div className="flex justify-center items-center h-full">
                <Loader />
            </div>
        );
    }

    if (homes.length === 0) {
        return (
            <div className="flex justify-center items-center h-full">
                <p>No hay tiendas disponibles</p>
            </div>
        );
    }

    return (
        <div className="mb-6 mt-8">
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-2 gap-6">
                {homes.sort((a, b) => new Date(b.created_at).getTime() - new Date(a.created_at).getTime()).map((home) => (
                    <HomesCard key={home.id} data={home} />
                ))}
            </div>
        </div>
    );
};

